export const uniq = <T>(arr: T[]) => Array.from(new Set(arr));
